import { useLocalStorageState } from 'ahooks'
import { LOCAL_USERINFO_KEY } from '@/utils/constants'

function useLocalUserInfo() {
  const [localUserInfo, setLocalUserInfo] = useLocalStorageState<any>(LOCAL_USERINFO_KEY)

  const addLocalUserInfo = (userInfo: any) => {
    setLocalUserInfo(userInfo)
  }
  const deleteLocalUserInfo = () => {
    setLocalUserInfo(undefined)
  }
  const getLocalUserInfo = () => {
    return localUserInfo
  }
  return {
    addLocalUserInfo,
    deleteLocalUserInfo,
    getLocalUserInfo
  }
}

export default useLocalUserInfo
